/**
 * Presupuesto por campaña INFORMATIVO en líneas globales (card CvdQbnl2, Fase 2).
 *
 * En una línea global el presupuesto es UNO y manda; desde esta card se puede cargar además un monto
 * por campaña, como hoy se hace con los objetivos. No reparte nada: sólo informa. Por eso nunca
 * bloquea — si la suma de las campañas no coincide con el global, se AVISA («no te coinciden») y el
 * usuario decide. Es la solución rudimentaria que acordó Pablo a propósito, para no trabar el armado.
 *
 * Los montos se comparan redondeados a entero porque así los guarda el backend (`IntegerField`): un
 * 1.000,4 contra un 1.000 no es un desfasaje que valga la pena gritar.
 */

export const INFORMATIVE_MATCH = 'MATCH';
export const INFORMATIVE_MISSING = 'MISSING'; // las campañas suman MENOS que el global
export const INFORMATIVE_EXCESS = 'EXCESS';   // las campañas suman MÁS que el global

/**
 * `{state, difference}` o `null` si no hay nada que comparar (sin global o sin ningún monto por
 * campaña cargado: una línea global sin presupuestos por campaña se ve exactamente como antes).
 */
export function compareInformativeBudget(lineBudget, campaignsSum) {
    if (lineBudget === null || lineBudget === undefined || lineBudget === '') return null;
    if (campaignsSum === null || campaignsSum === undefined || campaignsSum === '') return null;
    const line = Math.round(Number(lineBudget));
    const sum = Math.round(Number(campaignsSum));
    if (!Number.isFinite(line) || !Number.isFinite(sum)) return null;
    if (sum === line) return {state: INFORMATIVE_MATCH, difference: 0};
    return sum < line
        ? {state: INFORMATIVE_MISSING, difference: line - sum}
        : {state: INFORMATIVE_EXCESS, difference: sum - line};
}

/**
 * El monto del aviso con el formato de la pantalla donde se lee: `es-AR` («ARS 20.000») en la 2.1,
 * que es el de su Panel; `en-US` («ARS 20,000») en el Tablero clásico, cuyo input y celdas escriben
 * así. Con el mismo formato en todos lados, el modal decía «20,000» arriba y «ARS 20.000» abajo
 * (QA en producción, 27/09).
 */
export const INFORMATIVE_LOCALE_V21 = 'es-AR';
export const INFORMATIVE_LOCALE_CLASSIC = 'en-US';

export function formatInformativeMoney(currency, amount, locale = INFORMATIVE_LOCALE_V21) {
    const value = Math.round(Number(amount)) || 0;
    const text = value.toLocaleString(locale);
    return currency ? `${currency} ${text}` : text;
}

/** La suma que quedaría si esta campaña pasa a tener `amount`: las otras + la editada. */
export function sumWithEdited(otherCampaignsSum, amount) {
    const others = Number(otherCampaignsSum) || 0;
    const own = amount === null || amount === undefined || amount === '' ? 0 : Number(amount) || 0;
    return others + own;
}
